import { css } from '@/styled-system/css';

export const formFieldStyles = css.raw({
  '& > .c11n_label': {
    display: 'block',
    marginBlockEnd: 'tightest',
  },

  '& > .c11n_form-help': {
    marginBlockStart: 'tightest',
  },
});
